export function transformInToFormObject(data) {
  let formData = new FormData();
  for (let key in data) {
    if (Array.isArray(data[key]) && key !== "extra_pictures") {
      if(key === "variant_pictures"){
        data[key].forEach((obj) => {
          let keyList = Object.keys(obj);
  
          keyList.forEach((keyItem) => {
            let keyName = `data[variants][][picture]`;
  
            formData.append(keyName, obj);
          });
        });
      }else if(key === "supplier_ids"){
        data[key].forEach((obj) => {
          formData.append(`data[supplier_ids][]`, obj);
        });
      }else{
        // Compute all unique keys present across all objects in this array
        let allKeys = [];
        data[key].forEach((obj) => {
          Object.keys(obj).forEach((k) => {
            if (!allKeys.includes(k)) allKeys.push(k);
          });
        });

        // Ensure 'id' is always appended first if it exists, to guarantee correct Rack association
        if (allKeys.includes('id')) {
          allKeys.splice(allKeys.indexOf('id'), 1);
          allKeys.unshift('id');
        }

        // Emit every key for every object, filling in empty strings for missing ones
        data[key].forEach((obj) => {
          allKeys.forEach((keyItem) => {
            let keyName = `data[${key}][][${keyItem}]`;
            let val = obj[keyItem] !== undefined && obj[keyItem] !== null ? obj[keyItem] : '';
            formData.append(keyName, val);
          });
        });
      } 
    }else if(key === "extra_pictures"){
      // if(data[key].length > 0){
        data[key].map(item => {
          formData.append(`data[${key}][]`, item);
        })
      // }else{
      //   formData.append(`data[${key}]`, []);
      // }
    }
    // else if (typeof data[key] === "object") {
    //   for (let innerKey in data[key]) {
    //     formData.append(`data[${key}.${innerKey}]`, data[key][innerKey]);
    //   }
    // }
    else {
      formData.append(`data[${key}]`, data[key]);
    }
  }
  return formData;
}

// data[variants][][price]
